import { TransactionToastType } from './types';

/**
 * Success messages for transaction actions
 */
export const TOAST_MESSAGES = {
  SUCCESS_RETRY: 'Retry initiated successfully',
  SUCCESS_CASH_RECORDED: 'Cash payment recorded successfully',
  SUCCESS_CANCEL: 'Transaction cancelled',
  SUCCESS_REFUND: 'Payment refunded successfully',
  SUCCESS_ADJUSTMENT:
    'Sale recorded successfully. Please refresh after few seconds to see the updated sale.',
  ERROR_GENERIC: 'An unexpected error occured',
  ERROR_UNABLE_TO_PERFORM: 'We are unable to perform intended action. Please try again.',
} as const;

/**
 * Permission keys for transaction actions
 */
export const PERMISSION_KEYS = {
  CREATE_PAYMENT_ADJUSTMENT: 'msotreezpay::createPaymentAdjustment',
} as const;

/**
 * Get the appropriate toast message for a given toast type
 */
export function getToastMessage(toastType: TransactionToastType | null): string {
  switch (toastType) {
    case TransactionToastType.CASH:
      return TOAST_MESSAGES.SUCCESS_CASH_RECORDED;
    case TransactionToastType.RETRY:
      return TOAST_MESSAGES.SUCCESS_RETRY;
    case TransactionToastType.CANCEL:
      return TOAST_MESSAGES.SUCCESS_CANCEL;
    case TransactionToastType.REFUND:
      return TOAST_MESSAGES.SUCCESS_REFUND;
    case TransactionToastType.FAILED_CANCEL:
    case TransactionToastType.FAILED_CASH:
    case TransactionToastType.FAILED_RETRY:
    case TransactionToastType.FAILED_REFUND:
      return TOAST_MESSAGES.ERROR_GENERIC;
    default:
      return '';
  }
}

/**
 * Check if the toast type represents a failure
 */
export function isFailedToastType(toastType: TransactionToastType | null): boolean {
  return (
    toastType === TransactionToastType.FAILED_CANCEL ||
    toastType === TransactionToastType.FAILED_CASH ||
    toastType === TransactionToastType.FAILED_RETRY ||
    toastType === TransactionToastType.FAILED_REFUND
  );
}
